<form [formGroup]="formGroup">
  <p-autoComplete
    (completeMethod)="searchPravnoLice($event)"
    (onClear)="onClear()"
    (onKeyUp)="nazivChanged($event)"
    (onSelect)="selectionChanged($event)"
    [appendTo]="parentCtrl"
    [delay]="300"
    [forceSelection]="mustSelect"
    [inputId]="formCtrlId"
    [placeholder]="ctrlPlaceholder"
    [suggestions]="pravnaLicaSuggestions"
    emptyMessage="Stranka nije pronađena"
    field="naziv"
    formControlName="searchValue"
  >

    <!-- kraci naziv firme sa ... na kraju -->
    <ng-template let-item pTemplate="item">
      {{ item.naziv?.length > 57 
          ? (item.naziv | slice:0:57) + '...' 
          : item.naziv }}
    </ng-template>

  </p-autoComplete>

  <kodit-error-info-required
    [formCtrl]="formGroup.controls.searchValue"
  ></kodit-error-info-required>

  <small *ngIf="showEmptyMsg" class="p-text-secondary">
    Pravno lice nije pronađeno. Probajte pretragu po PIB-u ili matičnom broju,
    ili unesite ceo naziv firme.
  </small>
</form>